import CheckIcon from '@mui/icons-material/Check';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from 'tss-react/mui';

interface Props {
    selectHandler: (colour: string) => void;
    color?: string;
}

const colorArray = [
    { name: 'Red', color: '#ff1744' },
    { name: 'Pink', color: '#f73378' },
    { name: 'Purple', color: '#d500f9' },
    { name: 'Deep Purple', color: '#651fff' },
    { name: 'Indigo', color: '#3d5afe' },
    { name: 'Blue', color: '#5393ff' },
    { name: 'Light Blue', color: '#33bfff' },
    { name: 'Cyan', color: '#00e5ff' },
    { name: 'Teal', color: '#1de9b6' },
    { name: 'Green', color: '#00e676' },
    //{ name: 'Light Green', color: '#76ff03' },
    //{ name: 'Lime', color: '#c6ff00' },
    //{ name: 'Yellow', color: '#ffea00' },
    { name: 'Amber', color: '#ffc400' },
    { name: 'Orange', color: '#ff9100' },
    { name: 'Deep Orange', color: '#ff3d00' },
];

const ColourPicker = ({ selectHandler, color }: Props) => {
    const { classes } = useStyles();

    return (
        <Grid
            container
            justifyContent="space"
            alignItems="center"
            spacing={1}
            wrap="wrap"
            flexDirection="row"
            item
        >
            {colorArray.map((aColor, index) => (
                <Grid item onClick={() => selectHandler(aColor.color)} display="flex" key={index}>
                    <Tooltip title={aColor.name} placement="bottom" arrow disableInteractive>
                        <Button
                            variant="contained"
                            sx={{
                                display: 'flex',
                                flexGrow: 1,
                                width: '2rem',
                                height: '3rem',
                                backgroundColor: aColor.color,
                                borderRadius: '8px',
                            }}
                        >
                            {color === aColor.color ? <CheckIcon fontSize="medium" /> : null}
                        </Button>
                    </Tooltip>
                </Grid>
            ))}
        </Grid>
    );
};

export default ColourPicker;

const useStyles = makeStyles()(() => ({}));
